module.exports = __webpack_public_path__ + "static/img/til66.baf3e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til66.png
// module id = yNG3
// module chunks = 1